/* unplugin-vue-components disabled */import script from "./ConflictTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ConflictTable.vue?vue&type=script&setup=true&lang=js"

import "./ConflictTable.vue?vue&type=style&index=0&id=5c89d9aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c89d9aa"]])

export default __exports__